import { render } from "./AptBox.vue?vue&type=template&id=7191ca30&scoped=true"
import script from "./AptBox.vue?vue&type=script&lang=js"
export * from "./AptBox.vue?vue&type=script&lang=js"

import "./AptBox.vue?vue&type=style&index=0&id=7191ca30&scoped=true&lang=scss"

import exportComponent from "/home/forge/olyo.io/app-src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7191ca30"]])

export default __exports__